/**
 * Query-key conventions (README "Data"):
 *
 *   [domain, resource, ...params]
 *
 *  - `domain` is the feature or API area ('session', 'performance', …) so a
 *    whole area can be invalidated with one prefix.
 *  - Params are ONE plain, JSON-serialisable object as the last element, built
 *    from the same values sent to the API (never from UI draft state), so two
 *    screens asking the same question share a cache entry.
 *  - Keys are created only through a factory like the ones below — never
 *    written inline — so invalidation and reads cannot drift apart.
 */
export const sessionKeys = {
  all: ['session'] as const,
  me: () => [...sessionKeys.all, 'me'] as const,
  account: () => [...sessionKeys.all, 'account'] as const,
  billing: () => [...sessionKeys.all, 'billing'] as const,
  predictionOperator: () => [...sessionKeys.all, 'prediction-operator'] as const,
  connections: () => [...sessionKeys.all, 'connections'] as const,
};
